export default "__VITE_ASSET__CrgsXR1O__"